import React from 'react';
import { Button, Modal } from 'components/ui';
import { Box, Typography } from '@mui/material';
interface InstallPromptModalProps {
  open: boolean;
  onClose(): void;
  onInstall(): void;
}

function InstallPromptModal({
  open,
  onClose,
  onInstall,
}: InstallPromptModalProps) {
  return (
    <Modal title={'Get the CampusLush app!'} open={open} onClose={onClose}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 24,
          maxWidth: 520,
          margin: {
            xs: '0px',
            md: '0 24px',
          },
          flexDirection: {
            xs: 'column',
            md: 'row',
          },
        }}
      >
        <Box
          sx={{ maxWidth: '120px' }}
          component="img"
          src="/pwa_download.jpg"
        />
        <Box
          sx={{
            textAlign: 'left',
            flex: 1,
          }}
        >
          <Typography variant="body1" lineHeight={1.3} fontWeight={600} mb={16}>
            Scan or click the QR code to download the app to your phone
          </Typography>
          <Box
            mt={0}
            display="flex"
            alignItems="center"
            flexDirection="row"
            justifyContent="flex-start"
            gap={24}
          >
            <Button variant="vibrant" minHeight={48} onClick={onInstall}>
              Download App
            </Button>
            <Typography
              onClick={onClose}
              sx={{
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
            >
              Remind Me Later
            </Typography>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export default InstallPromptModal;
